import React from 'react';
import { SURPRESSION_TABLE, POMPE_SIMPLE_COST, BASCULE_EAU_VILLE_COST, shouldRecommendSurpression } from '../../calculations/pompageCalculations.js';
import RecommendationBanner from './RecommendationBanner.js';

/** Section Pompage & surpression : choix entre pompe simple et système de surpression, avec bascule eau de ville optionnelle. */
const PompageSection = ({ pompage, setPompage, usages }) => {
  const recommended = shouldRecommendSurpression(usages);

  return (
    <div>
      {recommended && (
        <RecommendationBanner>
          Un usage intérieur sous pression (WC ou lave-linge) est actif à l'étape 1 — un système de surpression avec
          bascule automatique vers le réseau d'eau de ville est recommandé pour ne jamais manquer d'eau. Pré-sélectionnés
          ci-dessous, librement modifiables.
        </RecommendationBanner>
      )}

      <div className="rw-budget-grid rw-budget-grid--2">
        <div
          className={`rw-budget-card ${pompage.mode === 'simple' ? 'rw-budget-card--selected' : ''}`}
          onClick={() => setPompage({ mode: 'simple' })}
        >
          <div className="rw-budget-card-label">Pompe simple</div>
          <div className="rw-budget-card-desc">Pompe immergée ou de surface — suffisant pour un usage extérieur (arrosage, lavage)</div>
          <div className="rw-budget-card-price">{POMPE_SIMPLE_COST.low} – {POMPE_SIMPLE_COST.high} €</div>
        </div>
        <div
          className={`rw-budget-card ${pompage.mode === 'surpression' ? 'rw-budget-card--selected' : ''}`}
          onClick={() => setPompage({ mode: 'surpression' })}
        >
          <div className="rw-budget-card-label">Système de surpression</div>
          <div className="rw-budget-card-desc">Mise en pression pour un réseau intérieur (WC, lave-linge) — bascule eau de ville en option ci-dessous</div>
          <div className="rw-budget-card-price">À partir de {SURPRESSION_TABLE.d2.mat[0] + SURPRESSION_TABLE.d2.pose[0]} €</div>
        </div>
      </div>

      {pompage.mode === 'surpression' && (
        <>
          <div className="rw-param-row">
            <div className="rw-param-field">
              <label>Débit nécessaire</label>
              <select value={pompage.surpressionDebit} onChange={e => setPompage({ surpressionDebit: e.target.value })}>
                <option value="d2">Jusqu'à 2 m³/h</option>
                <option value="d5">2,1 à 5 m³/h</option>
                <option value="d10">5,1 à 10 m³/h</option>
                <option value="dplus">Plus de 10 m³/h</option>
              </select>
            </div>
          </div>

          <label className="rw-checkbox-opt" style={{ marginTop: 12 }}>
            <input
              type="checkbox"
              checked={!!pompage.bascule}
              onChange={e => setPompage({ bascule: e.target.checked })}
            />
            <div>
              <div className="rw-budget-card-label">Bascule automatique vers le réseau d'eau de ville</div>
              <div className="rw-budget-card-desc">
                Remplit la cuve à l'eau de ville en cas de manque, pour assurer la continuité des usages critiques
                raccordés (WC, lave-linge) — disconnexion normalisée
              </div>
              <div className="rw-budget-card-price">{BASCULE_EAU_VILLE_COST.low} – {BASCULE_EAU_VILLE_COST.high} €</div>
            </div>
          </label>
        </>
      )}
    </div>
  );
};

export default PompageSection;
